import { colorPalette } from "../../config/colorPalette";

// Label row shared by Checkbox, Radio and Switch (Figma body3: Lexend 14 / 1.45).
export const rowSx = (disabled) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  position: "relative",
  cursor: disabled ? "not-allowed" : "pointer",
  fontFamily: '"Lexend", sans-serif',
  fontSize: 14,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: 1.45,
  letterSpacing: "0.1px",
  color: disabled ? colorPalette.mercuryAlpha[28] : colorPalette.mercury[950],
});

// Native input stays in the DOM for keyboard and screen readers; the next sibling
// span draws the control from the input's :checked / :disabled state.
export const hiddenInputSx = {
  position: "absolute",
  opacity: 0,
  width: 0,
  height: 0,
  margin: 0,
};

export const controlBaseSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  boxSizing: "border-box",
};

// Not in Figma: keyboard focus ring.
export const focusRingSx = {
  outline: `2px solid ${colorPalette.brand[700]}`,
  outlineOffset: 2,
};
